export default __webpack_public_path__ + "f560f32a08e47f8720a0a89ca56a0f20.ttf";